import moment from 'moment';

export const formatDate = (date: Date) => {
  return moment(date).format('MM/DD/YYYY');
};

export const formatDateWithTime = (date: Date | string | number) => {
  return moment(date).format('MM/DD/YYYY hh:mm A');
};
